import { ConfirmationDialog } from "../../../assets/types/common";
import { Constants } from "../../../assets/utils/lib/constants";
import { LoadingIndicator } from "../../../assets/vfx";
import Drawer from "../../../assets/vfx/drawer/drawer";

import DisplayData from "../../common/DisplayData/DisplayData";
import { ReferenceDto } from "../../../services/dto";
import { LookupDto } from "../../../assets/utils/lib/lookupDto";

interface ReferenceViewProps {
    data: ReferenceDto | undefined;
    show: boolean;
    linkType: string;
    pageLinks: LookupDto[];
    references: ReferenceDto[];
    onHide: () => void;
    onEdit: () => void;
    onDelete: () => void;
}

export const ReferenceView = (props: ReferenceViewProps) => {
    const title: string = `${props?.data?.display ?? props.linkType}`;
    const pageLink: string | undefined = props.pageLinks.find(
        (link) => link.id === props.data?.pageLinkId
    )?.display;
    const proxy: string | undefined = props.references.find(
        (reference) => reference.id === props.data?.proxyId
    )?.display;

    return (
        <Drawer.View
            className="w-30"
            show={props.show}
            backdrop
            placement="end"
            scroll
            title={title}
            modalDialogProps={new ConfirmationDialog().get(props.onDelete, "Delete", { Name: props.data?.display ?? Constants.emptyString, })}
            onHide={props.onHide}
            //onEdit={props.onEdit}
            onDelete={props.onDelete}
        >
            {!props.data ? (
                <LoadingIndicator isFullPage />
            ) : (
                <>
                    <DisplayData
                        text="Description"
                        importedData={props.data.description ?? Constants.emptyString}
                    />
                    {proxy && <DisplayData text="Proxy" importedData={proxy} />}
                    <DisplayData
                        text="Background Color"
                        importedData={props.data.iconBackgroundColor ?? Constants.emptyString}
                    />
                    <DisplayData
                        text="Foreground Color"
                            importedData={props.data.iconForecolor ?? Constants.emptyString}
                    />
                    <DisplayData
                        text="Icon Type"
                        importedData={props.data.iconType ?? Constants.emptyString}
                    />
                    <DisplayData
                        text="Icon Name"
                        importedData={props.data.iconName ?? Constants.emptyString}
                    />
                    {props.data.url && (
                        <DisplayData text="URL" importedData={props.data.url} />
                    )}
                    {pageLink && <DisplayData text="Page Link" importedData={pageLink} />}
                    {props.data.image && (
                        <DisplayData
                            text="Image"
                            importedData={props.data.image}
                            imageStyle={{
                                width: 100,
                                height: 100,
                                objectFit: "cover",
                                border: "1px solid #ccc",
                                borderRadius: 4,
                            }}
                        />
                    )}
                    {props.data.backgroundImage && (
                        <DisplayData
                            text="Background Image"
                            importedData={props.data.backgroundImage}
                            imageStyle={{
                                width: 100,
                                height: 100,
                                objectFit: "cover",
                                border: "1px solid #ccc",
                                borderRadius: 4,
                            }}
                        />
                    )}
                    {props.data.headerImage && (
                        <DisplayData
                            text="Header Image"
                            importedData={props.data.headerImage}
                            imageStyle={{
                                width: 100,
                                height: 100,
                                objectFit: "cover",
                                border: "1px solid #ccc",
                                borderRadius: 4,
                            }}
                        />
                    )}
                </>
            )}
        </Drawer.View>
    );
};
